import DepsService from 'services/dependencies';

const CONTEXT = 'dashboard';

export const fetchMyCurrentLiability = (retailerId) => {
  const { url } = DepsService.rest.widgets.instant.myCurrentLiability;
  const queryParams = {};
  const urlParams = { retailerId };

  return DepsService.restSrv.list(CONTEXT, url, queryParams, urlParams);
};



// WEBPACK FOOTER //
// ./src/modules/dashboard/resources/current-instant-game-liability.api.js